import Grid from "@mui/material/Grid";
import {Divider} from "@mui/material";
import PickRowReverseTopMoments from "../PickRowReverseTopMoments";
import Paper from "@mui/material/Paper";
import {TwoWidePickBlockTopMomentsProps} from "./PickBlockTopMoments";

export default function PickBlockReverseTopMoments({pick, result, updatePick, picks_locked}: Readonly<TwoWidePickBlockTopMomentsProps>){
    return (
        <Grid container component={Paper} m={1} sx={{
            display: 'flex',
            flexDirection: "column",
            height: 'fit-content',
            width: 'fit-content',
        }}>
            <PickRowReverseTopMoments
                competitor_number={1}
                pick={pick}
                result={result}
                onClick={updatePick}
                picks_locked={picks_locked}
                fourWide={false}
            />
            <Divider/>
            <PickRowReverseTopMoments
                competitor_number={2}
                pick={pick}
                result={result}
                onClick={updatePick}
                picks_locked={picks_locked}
                fourWide={false}
            />
        </Grid>
    )
}
